import React from "react";
import { useEffect } from "react";
// import Header from "../../components/common/Header";
// import Footer from "../../components/common/Footer";

// Import the components you copied
import { HeroSection } from "./components/HeroSection";
//import { FormSection } from "./components/FormSection";
import { PricingSection } from "./components/PricingSection";
import { FeaturesSection } from "./components/FeaturesSection";
import { ProcessSection } from "./components/ProcessSection";
import { ReportContentsSection } from "./components/ReportContentsSection";
import { AboutSection } from "./components/AboutSection";
import { ExpertSection } from "./components/ExpertSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { FinalCTASection } from "./components/FinalCTASection";
import SectionHeading from './components/SectionHeading.jsx';
import CelebrityExperiences from './components/CelebrityExperiences.jsx';
import { captureUTMFromURL } from "../../utils/utm";

const LifeChangingReport = () => {
  
  useEffect(() => {
    captureUTMFromURL();
  }, []);

  return (
    <>
      
      <main className="bg-[#1e0e0e] text-white">
        <HeroSection />
        <div className="py-10 relative z-10 space-y-16 md:space-y-24 pb-24 md:pb-32">
          <section className="">
            <article className="px-5 py-5 space-y-5 text-cosmic-gold">
              <SectionHeading
                tag="TRUSTED BY CELEBRITIES"
                tagBg="#ffd24c"
                tagColor="#ffd24c"
                title="Celebrity"
                highlight="Experiences"
                subtitle="Hear how top stars found clarity, guidance, and success through astrology."
              />
              <CelebrityExperiences />
            </article>
          </section>
          <FeaturesSection />
          <AboutSection />
          <ProcessSection />
          <ReportContentsSection />
          <PricingSection />
          <TestimonialsSection />
          <ExpertSection />
          <FinalCTASection />
        </div>
      </main>
      
    </>
  );
};

export default LifeChangingReport;